/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from "@material-ui/core/";
import React, { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import TableOnUsers from "./TableOnConfig";

const useStyles = makeStyles((theme) => ({
	root: {
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
}));

const ListConfig = (props) => {
	const classes = useStyles();
	const BaseUrl = `${url.list_config}`;
	const fetchData = useContext(FetchDataContext);
	const { getDataTables, updateData, tableRef } = fetchData;
	const [state] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { pageSize } = state;

	const handleFetchUpdate = () => {
		return true;
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "status")
			result = await updateData(
				`${BaseUrl}/edit_config?id=${data.id}`,
				data,
				handleFetchUpdate
			);

		return result;
	};

	return (
		<Grid direction="column" alignItems="center" className={classes.root}>
			<TableOnUsers
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				pageSize={pageSize}
				tableRef={tableRef}
				fetchAPI={fetchAPI}
			/>
		</Grid>
	);
};
export default ListConfig;
